export const fuelWeeks = [
  {
    name: 'Current Week',
    value: 'current',
    localizationSlug: 'CURRENT_WEEK',
  },
  {
    name: 'Previous Week',
    value: 'previous',
    localizationSlug: 'PREVIOUS_WEEK',
  },
];

export const fuelDays = [
  {
    name: 'Monday',
    value: 'monday',
    localizationSlug: 'MONDAY',
  },
  {
    name: 'Tuesday',
    value: 'tuesday',
    localizationSlug: 'TUESDAY',
  },
  {
    name: 'Wednesday',
    value: 'wednesday',
    localizationSlug: 'WEDNESDAY',
  },
];

export const fuelMatrixOptions = [
  {
    name: 'Default',
    value: 'default',
    localizationSlug: 'DEFAULT',
    titleize: true
  },
  {
    name: 'Customer',
    value: 'customer',
    localizationSlug: 'CUSTOMER',
    titleize: true
  },
];
